/** The longest a review's comments may be. */
export const REVIEW_BODY_MAX = 4000

/** The longest reason an admin gives for declining a review. Its writer reads it. */
export const REVIEW_DECLINE_REASON_MAX = 500

/** Reviews the admins' page lists at once, the longest waiting first; it says how many wait in all. */
export const REVIEWS_TO_APPROVE_SHOWN = 50

/** Reviews a vendor's page and profile show, most recently published first. Their summary counts them all. */
export const REVIEWS_SHOWN = 20

/** The longest a company's reply to a review may be. */
export const REVIEW_REPLY_MAX = 2000

/** The longest reason a company gives for reporting a review. */
export const REVIEW_REPORT_MAX = 1000
